import React from 'react';
import Scrollspy from 'react-scrollspy';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import Paragraphs from '../components/Paragraphs';
import ScrollToTop from '../components/ScrollToTop';
import CTA from '../components/CTA';
import Spacer from '../components/Spacer';
import Button from '../components/Button';
// import SEO from '../components/SEO';

import '../css/webdev.css';

class SocialMediaMarketing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      position: null,
      viewportWidth: null,
      progressPerc: 20
    };
  }
  componentDidMount() {
    let { details } = this.props.data(this.props.type);
    const increment =
      details &&
      details.Curriculum &&
      details.Curriculum.timeline &&
      details.Curriculum.timeline.length
        ? 100 / details.Curriculum.timeline.length
        : 20;
    this.setState({ progressPerc: increment });

    window.addEventListener('scroll', this.listenToScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll);
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const viewportWidth = window.innerWidth;
    // const height =
    //     document.documentElement.scrollHeight -
    //     document.documentElement.clientHeight
    // const scrolled = winScroll / height

    this.setState({
      position: winScroll,
      viewportWidth
    });
  };
  render() {
    let { heading, img, text, type, impInfo, details } = this.props.data(
      this.props.type
    );
    const increment =
      details &&
      details.Curriculum &&
      details.Curriculum.timeline &&
      details.Curriculum.timeline.length
        ? 100 / details.Curriculum.timeline.length
        : 20;
    // console.log('this.state/', this.state.position);
    return (
      <>
        <div className="course-page">
          <ScrollToTop />
          <section id="intro">
            <div className="left">
              <span className="tag type">{type}</span>
              <p className="info">{impInfo}</p>
              <h1>{heading}</h1>
              <Paragraphs data={text} light={true} />
              <a
                href="#curriculum"
                className="btn btn-outline btn-outline-blue margin-right-15"
              >
                View Details
              </a>
              <Button type="apply" />
            </div>
            <div className="right">
              <img
                src={img}
                alt="Manage Your Business Social Media Accounts at WE3 Academy"
              />
            </div>
          </section>

          <section id="course__details">
            <nav>
              <ul
                className="sidebar"
                style={
                  this.state.position > 730 &&
                  this.state.viewportWidth >= 768 &&
                  this.state.position < this.props.scrollMax
                    ? { position: 'fixed', top: '20px' }
                    : { position: 'relative' }
                }
              >
                <Scrollspy
                  items={Object.keys(details).map(
                    (sidebarItem) => details[sidebarItem].link
                  )}
                  currentClassName="is-current"
                >
                  {Object.keys(details).map((sidebarItem, index) => (
                    <li key={index}>
                      <a
                        href={
                          details[sidebarItem].link
                            ? `#${details[sidebarItem].link}`
                            : '/'
                        }
                      >
                        {sidebarItem}
                      </a>
                    </li>
                  ))}
                </Scrollspy>
                <li>
                  <Button
                    type="apply"
                    customClass="btn btn-filled btn-filled-black"
                  />
                </li>
              </ul>
            </nav>
            <div id="course__details-container">
              {Object.keys(details).map((detailKey, index) => {
                let detailValue = details[detailKey];
                return (
                  <section key={index} id={detailValue.link}>
                    {detailValue && detailValue.heading && (
                      <h2 className="blue">{detailValue.heading}</h2>
                    )}
                    {detailValue && detailValue.text && (
                      <Paragraphs data={detailValue.text} light={true} />
                    )}
                    {detailValue &&
                      detailValue.sections &&
                      detailValue.sections.length > 0 &&
                      detailValue.sections.map((singleSection, index) => {
                        return (
                          <div className="sections-inner" key={index}>
                            <h2 className="blue">{singleSection.heading}</h2>
                            {singleSection && singleSection.text && (
                              <Paragraphs
                                data={singleSection.text}
                                light={true}
                              />
                            )}
                            {singleSection && singleSection.features && (
                              <div className="sections-inner-features">
                                {singleSection.features.map(
                                  (feature, innerIdx) => (
                                    <div key={innerIdx}>
                                      <p>{feature.caption}</p>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                            {singleSection &&
                              singleSection.details &&
                              singleSection.details.map((detail, innerIdx) => (
                                <div key={innerIdx}>
                                  <h3>{detail.heading}</h3>
                                  <Paragraphs data={detail.text} light={true} />
                                </div>
                              ))}
                            {singleSection &&
                              singleSection.icons &&
                              singleSection.icons.length > 0 && (
                                <div className="icons">
                                  {singleSection.icons.map(
                                    (icon, iconIndex) => (
                                      <div
                                        key={iconIndex}
                                        className="img-container"
                                      >
                                        <img
                                          key={iconIndex}
                                          src={icon.icon}
                                          alt={icon.alt}
                                        />
                                        <p className="text-light">
                                          {icon.label}
                                        </p>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                          </div>
                        );
                      })}
                    {detailValue &&
                      detailValue.list &&
                      detailValue.list.length > 0 && (
                        <ul id="requirements__list">
                          {detailValue.list.map((req, index) => (
                            <li key={index}>{req}</li>
                          ))}
                        </ul>
                      )}
                    {/* TIMELINE FOR CURRICULUM */}
                    {detailValue &&
                      detailValue.timeline &&
                      detailValue.timeline.length > 0 && (
                        <section
                          id="curriculum"
                          className="timeline-block-container"
                        >
                          <div className="timeline-block">
                            {detailValue.timeline.map(
                              (timelineItem, timelineItemIdx) => (
                                <div
                                  style={{ width: `${increment}%` }}
                                  className="timeline-block-inner"
                                  key={timelineItemIdx}
                                  onClick={() =>
                                    this.setState({
                                      progressPerc:
                                        (timelineItemIdx + 1) * increment
                                    })
                                  }
                                >
                                  <p className="small-text text-light uppercase">
                                    {timelineItem.duration}
                                  </p>
                                  <p className="uppercase timeline-item-title">
                                    {timelineItem.title}
                                  </p>
                                </div>
                              )
                            )}
                          </div>
                          <div
                            className="progress-bar"
                            onClick={() =>
                              this.state.progressPerc &&
                              this.state.progressPerc !== 100
                                ? this.setState({
                                    progressPerc:
                                      this.state.progressPerc + increment
                                  })
                                : {}
                            }
                            style={{
                              background: `linear-gradient(to right, var(${
                                this.state.progressPerc > 60
                                  ? '--yellow'
                                  : '--blue'
                              }) ${this.state.progressPerc}%, white ${
                                this.state.progressPerc
                              }%, white ${100 - this.state.progressPerc}%)`
                            }}
                          ></div>

                          <div className="timeline-block icon-timeline">
                            {detailValue.timeline.map(
                              (timelineItem, timelineItemIdx) => (
                                <div
                                  style={{ width: `${increment}%` }}
                                  className="timeline-block-inner"
                                  key={timelineItemIdx}
                                >
                                  <img
                                    src={timelineItem.icon}
                                    alt={timelineItem.title}
                                    onClick={() =>
                                      this.setState({
                                        progressPerc:
                                          (timelineItemIdx + 1) * increment
                                      })
                                    }
                                  />
                                </div>
                              )
                            )}
                          </div>

                          {detailValue.timeline.map(
                            (timelineItem, timelineItemIdx) => (
                              <div
                                key={timelineItemIdx}
                                className="condensed-details"
                                id={`details-${
                                  (timelineItemIdx + 1) * increment
                                }`}
                                style={
                                  this.state.progressPerc / increment !==
                                  timelineItemIdx + 1
                                    ? { display: 'none' }
                                    : { display: 'block' }
                                }
                              >
                                {timelineItem.breakdown &&
                                  timelineItem.breakdown.length > 0 &&
                                  timelineItem.breakdown.map(
                                    (timelineItemDetails, idx) => (
                                      <div
                                        className="timeline-details"
                                        key={idx}
                                      >
                                        <h3>
                                          <span className="text-light">
                                            {timelineItemDetails.heading}
                                          </span>
                                          &nbsp;
                                          <span className="yellow">
                                            {timelineItemDetails.descriptor}
                                          </span>
                                        </h3>
                                        {timelineItemDetails.text &&
                                          timelineItemDetails.text.length >
                                            0 && (
                                            <Paragraphs
                                              data={timelineItemDetails.text}
                                              light={true}
                                            />
                                          )}
                                        {/* {timelineItemDetails.summary && timelineItemDetails.summary.length > 0 &&  timelineItemDetails.summary.map((summaryItem, sumIdx) => (
                                                                            <p key={sumIdx}>{summaryItem}</p>
                                                                        ))} */}
                                      </div>
                                    )
                                  )}
                              </div>
                            )
                          )}
                        </section>
                      )}

                    {/* CTA SECTION */}
                    {detailValue && detailValue.cta && (
                      <div className="detail-cta">
                        <Paragraphs data={detailValue.cta.text} />
                        <button className="btn btn-outline btn-outline-blue">
                          {detailValue.cta.button}
                        </button>
                      </div>
                    )}

                    {/* DATES & COSTS */}
                    {detailValue &&
                      detailValue.tuition &&
                      detailValue.tuition.length > 0 && (
                        <div className="tuition">
                          {detailValue.tuition.map((tuition, idx) => (
                            <React.Fragment key={idx}>
                              <div className="tuition__item">
                                <p className="tuition__item-title">
                                  {tuition.title}
                                </p>
                                <p className="yellow bold">
                                  {tuition.currency} {tuition.amount}
                                </p>
                              </div>
                              {idx + 1 !== detailValue.tuition.length && (
                                <span className="separator">/</span>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                    {detailValue && detailValue.schedule && (
                      <div className="schedule">
                        <p>{detailValue.schedule.title}</p>
                        <p className="date yellow bold">
                          {detailValue.schedule.startDate} - &nbsp;
                          {detailValue.schedule.endDate}
                        </p>
                        <p>{detailValue.schedule.timings}</p>
                      </div>
                    )}

                    {/* APPLICATION PROCESS */}
                    {detailValue &&
                      detailValue.process &&
                      detailValue.process.length > 0 && (
                        <div className="process">
                          {detailValue.process.map((process, idx) => (
                            <div className="process__block" key={idx}>
                              <div className="process__block-number">
                                <span className="text-light process__block-step">
                                  {idx + 1}
                                </span>
                                <span className="border-line"></span>
                              </div>
                              <span>
                                {process.heading && <h3>{process.heading}</h3>}
                                {process.text && (
                                  <Paragraphs data={process.text} />
                                )}
                                {process.button && (
                                  <Button
                                    type={process.button.type}
                                    customClass={process.button.customClass}
                                  />
                                )}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}

                    {/* FAQ */}
                    {detailValue && detailValue.faq && (
                      <Accordion
                        className="faq"
                        allowMultipleExpanded={true}
                        allowZeroExpanded={true}
                      >
                        {detailValue.faq.map((faq, faqIdx) => (
                          <AccordionItem key={faqIdx}>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                <span>{faq.question}</span>
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <Paragraphs data={faq.answer} />
                            </AccordionItemPanel>
                          </AccordionItem>
                        ))}
                        <Spacer px={35} />
                        <Button
                          type={detailValue.button.type}
                          customText="View All FAQs"
                        />
                      </Accordion>
                    )}

                    {/* DISLAIMER */}
                    {detailValue && detailValue.disclaimer && (
                      <div className="disclaimer">{detailValue.disclaimer}</div>
                    )}
                  </section>
                );
              })}
            </div>
          </section>
          <section id="section-cta">
            <CTA styleType="style1" />
          </section>
        </div>
      </>
    );
  }
}

export default SocialMediaMarketing;
